export default __webpack_public_path__ + "static/media/Avoidance setup.cc24fac5.jpg";